import { render } from "./debugPage.vue?vue&type=template&id=3f79db84"
import script from "./debugPage.vue?vue&type=script&lang=js"
export * from "./debugPage.vue?vue&type=script&lang=js"

import "./debugPage.vue?vue&type=style&index=0&id=3f79db84&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__